module.exports = __webpack_public_path__ + "static/media/room-4.86575b91.jpg";